'use client';

import Image from 'next/image';
import Link from 'next/link';

import call from 'public/icons/call.svg';
import mail from 'public/icons/mail.svg';

import styles from './styles.module.scss';

const ContactInfo = () => {
  return (
    <div className={styles.contactLinks}>
      <div className={styles.link}>
        <Image src={mail} alt="mail icon" width={24} height={24} />
        <Link href="mailto:hello@unitra.com">hello@unitra.com</Link>
      </div>

      <div className={styles.telNumber}>
        <Image src={call} alt="telephone icon" width={24} height={24} />
        <p>{TEL_NUMBER}</p>
      </div>
    </div>
  );
};

const TEL_NUMBER = '+48 780 781 430';

export default ContactInfo;
